// // import React from 'react'
// // import Navbar from './Navbar'
// // import Footer from './Footer'

// // const SupervisorDashboard = () => {
// //   return (
// //     <>
// //     <Navbar/>
// //     <div>
// //     SupervisorDashboard
// //     </div>
// //     <Footer />
// //     </>
// //   )
// // }

// // export default SupervisorDashboard


// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import styled from 'styled-components';
// import { useNavigate } from 'react-router-dom';
// import NavBarSuper from './NavBarSuper';
// import Footer from './Footer';

// const AppContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   min-height: 100vh;
//   background: linear-gradient(180deg, #f8fafc 0%, #eef4ff 100%);
// `;

// const PageWrapper = styled.div`
//   flex: 1 0 auto;
//   width: min(1200px, calc(100% - 32px));
//   margin: 90px auto 30px;

//   @media (max-width: 768px) {
//     width: min(100%, calc(100% - 20px));
//     margin-top: 80px;
//   }

//   @media (max-width: 480px) {
//     width: min(100%, calc(100% - 16px));
//     margin-top: 75px;
//   }
// `;

// const HeroCard = styled.div`
//   background: linear-gradient(135deg, #0f172a 0%, #1d4ed8 100%);
//   color: #fff;
//   border-radius: 24px;
//   padding: 28px;
//   margin-bottom: 22px;
//   box-shadow: 0 20px 40px rgba(15, 23, 42, 0.12);

//   @media (max-width: 768px) {
//     padding: 22px 18px;
//     border-radius: 20px;
//   }
// `;

// const HeroTitle = styled.h1`
//   margin: 0 0 8px;
//   font-size: clamp(1.4rem, 1.1rem + 1.2vw, 2.2rem);
//   font-weight: 800;
//   line-height: 1.2;
// `;

// const HeroText = styled.p`
//   margin: 0;
//   color: rgba(255, 255, 255, 0.86);
//   line-height: 1.6;
//   font-size: 0.98rem;
// `;

// const ContentCard = styled.div`
//   background: rgba(255, 255, 255, 0.96);
//   border-radius: 22px;
//   padding: 24px;
//   box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);
//   border: 1px solid rgba(148, 163, 184, 0.16);

//   @media (max-width: 768px) {
//     padding: 18px;
//     border-radius: 18px;
//   }
// `;

// const HeaderRow = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   gap: 14px;
//   margin-bottom: 20px;
//   flex-wrap: wrap;
// `;

// const Title = styled.h2`
//   color: #0f172a;
//   font-size: clamp(1.15rem, 1rem + 0.6vw, 1.6rem);
//   font-weight: 800;
//   margin: 0;
// `;

// const CountBadge = styled.div`
//   padding: 10px 14px;
//   border-radius: 999px;
//   background: #e0ecff;
//   color: #1d4ed8;
//   font-weight: 700;
//   font-size: 0.92rem;
// `;

// const AppraisalGrid = styled.div`
//   display: grid;
//   grid-template-columns: repeat(2, minmax(0, 1fr));
//   gap: 16px;

//   @media (max-width: 900px) {
//     grid-template-columns: 1fr;
//   }
// `;

// const AppraisalCard = styled.button`
//   width: 100%;
//   padding: 18px;
//   border: 1px solid #e2e8f0;
//   border-radius: 18px;
//   background: #fff;
//   cursor: pointer;
//   transition: all 0.25s ease;
//   text-align: left;
//   display: flex;
//   flex-direction: column;
//   gap: 16px;

//   &:hover {
//     background: #f8fbff;
//     transform: translateY(-2px);
//     box-shadow: 0 12px 24px rgba(15, 23, 42, 0.08);
//     border-color: #bfdbfe;
//   }

//   @media (max-width: 480px) {
//     padding: 16px;
//     border-radius: 16px;
//   }
// `;

// const TopRow = styled.div`
//   display: flex;
//   justify-content: space-between;
//   gap: 14px;
//   align-items: flex-start;
//   flex-wrap: wrap;
// `;

// const UserInfo = styled.div`
//   min-width: 0;
// `;

// const UserName = styled.h3`
//   margin: 0 0 8px;
//   color: #0f172a;
//   font-size: 1.05rem;
//   font-weight: 800;
//   line-height: 1.4;
//   word-break: break-word;
// `;

// const DetailText = styled.p`
//   margin: 4px 0;
//   color: #64748b;
//   font-size: 0.95rem;
//   line-height: 1.5;
//   word-break: break-word;

//   span {
//     color: #334155;
//     font-weight: 700;
//   }
// `;

// const PeriodTag = styled.div`
//   padding: 8px 12px;
//   border-radius: 999px;
//   background: #eff6ff;
//   color: #1d4ed8;
//   font-weight: 700;
//   font-size: 0.85rem;
//   white-space: nowrap;
// `;

// const BottomRow = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   gap: 12px;
//   flex-wrap: wrap;
// `;

// const SubmittedText = styled.p`
//   margin: 0;
//   color: #64748b;
//   font-size: 0.9rem;
// `;

// const ViewAction = styled.span`
//   color: #2563eb;
//   font-weight: 700;
//   font-size: 0.92rem;
// `;

// const StateBox = styled.div`
//   text-align: center;
//   padding: 50px 20px;
//   border-radius: 18px;
//   background: ${({ type }) =>
//     type === 'error' ? '#fef2f2' : type === 'empty' ? '#f8fafc' : '#ffffff'};
//   color: ${({ type }) =>
//     type === 'error' ? '#dc2626' : '#64748b'};
//   border: 1px solid
//     ${({ type }) =>
//       type === 'error' ? '#fecaca' : '#e2e8f0'};
//   font-size: 1rem;
// `;

// const SupervisorDashboard = ({ user }) => {
//   const [appraisals, setAppraisals] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchAppraisals = async () => {
//       try {
//         const response = await axios.get(
//           'https://api.stdl.site/api/appraisal/populated',
//           {
//             headers: {
//               Authorization: `Bearer ${localStorage.getItem('token')}`
//             }
//           }
//         );

//         setAppraisals(response.data.appraisals || []);
//       } catch (err) {
//         setError(
//           err.response?.data?.message || err.message || 'Failed to fetch appraisals'
//         );
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchAppraisals();
//   }, []);

//   const handleAppraisalClick = (appraisalId) => {
//     navigate(`/supervisor/appraisal/${appraisalId}`);
//   };

//   return (
//     <AppContainer>
//       <NavBarSuper user={user} />

//       <PageWrapper>
//         <HeroCard>
//           <HeroTitle>
//             Supervisor's Dashboard
//           </HeroTitle>
//           <HeroText>
//             Review staff submissions, track appraisal periods, and open each record for full assessment.
//           </HeroText>
//         </HeroCard>

//         <ContentCard>
//           <HeaderRow>
//             <Title>Staff Appraisal Submissions</Title>
//             <CountBadge>{appraisals.length} Submission{appraisals.length !== 1 ? 's' : ''}</CountBadge>
//           </HeaderRow>

//           {loading ? (
//             <StateBox>Loading appraisals...</StateBox>
//           ) : error ? (
//             <StateBox type="error">Error: {error}</StateBox>
//           ) : appraisals.length > 0 ? (
//             <AppraisalGrid>
//               {appraisals.map((appraisal) => (
//                 <AppraisalCard
//                   key={appraisal._id}
//                   onClick={() => handleAppraisalClick(appraisal._id)}
//                   type="button"
//                 >
//                   <TopRow>
//                     <UserInfo>
//                       <UserName>
//                         {appraisal.userDetails?.username || 'Unknown User'}
//                       </UserName>
//                       <DetailText>
//                         <span>Role:</span> {appraisal.userDetails?.role || 'N/A'}
//                       </DetailText>
//                       <DetailText>
//                         <span>Unit:</span> {appraisal.userDetails?.unit || 'N/A'}
//                       </DetailText>
//                     </UserInfo>

//                     <PeriodTag>
//                       {appraisal.appraisalPeriod || 'No Period'}
//                     </PeriodTag>
//                   </TopRow>

//                   <BottomRow>
//                     <SubmittedText>
//                       Submitted: {appraisal.createdAt
//                         ? new Date(appraisal.createdAt).toLocaleDateString()
//                         : 'N/A'}
//                     </SubmittedText>
//                     <ViewAction>View Appraisal →</ViewAction>
//                   </BottomRow>
//                 </AppraisalCard>
//               ))}
//             </AppraisalGrid>
//           ) : (
//             <StateBox type="empty">No appraisals found.</StateBox>
//           )}
//         </ContentCard>
//         <HeaderRow>
//   <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
//     <Title>Staff Appraisal Submissions</Title>
//     <CountBadge>{appraisals.length} Submission{appraisals.length !== 1 ? 's' : ''}</CountBadge>
//   </div>
//   <button 
//     onClick={() => navigate('/supervisor/team')}
//     style={{
//       padding: '10px 20px', backgroundColor: '#1d4ed8', color: 'white', 
//       border: 'none', borderRadius: '12px', fontWeight: 'bold', cursor: 'pointer'
//     }}
//   >
//     Manage My Team
//   </button>
// </HeaderRow>
//       </PageWrapper>
//       <Footer />
//     </AppContainer>
//   );
// };

// export default SupervisorDashboard;


// import React, { useState, useEffect } from 'react';
// import styled from 'styled-components';
// import { useNavigate } from 'react-router-dom';
// import NavBarSuper from './NavBarSuper';
// import Footer from './Footer';
// import api from '../api'; // Using your configured axios instance

// /* ================= STYLED COMPONENTS ================= */
// const AppContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   min-height: 100vh;
//   background: linear-gradient(180deg, #f8fafc 0%, #eef4ff 100%);
// `;

// const PageWrapper = styled.div`
//   flex: 1 0 auto;
//   width: min(1200px, calc(100% - 32px));
//   margin: 90px auto 30px;

//   @media (max-width: 768px) {
//     width: min(100%, calc(100% - 20px));
//     margin-top: 80px;
//   }

//   @media (max-width: 480px) {
//     width: min(100%, calc(100% - 16px));
//     margin-top: 75px;
//   }
// `;

// const HeroCard = styled.div`
//   background: linear-gradient(135deg, #0f172a 0%, #1d4ed8 100%);
//   color: #fff;
//   border-radius: 24px;
//   padding: 28px;
//   margin-bottom: 22px;
//   box-shadow: 0 20px 40px rgba(15, 23, 42, 0.12);
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   flex-wrap: wrap;
//   gap: 20px;

//   @media (max-width: 768px) {
//     padding: 22px 18px;
//     border-radius: 20px;
//   }
// `;

// const HeroTitle = styled.h1`
//   margin: 0 0 8px;
//   font-size: clamp(1.4rem, 1.1rem + 1.2vw, 2.2rem);
//   font-weight: 800;
//   line-height: 1.2;
// `;

// const HeroText = styled.p`
//   margin: 0;
//   color: rgba(255, 255, 255, 0.86);
//   line-height: 1.6;
//   font-size: 0.98rem;
// `;

// const ManageTeamButton = styled.button`
//   background: #fff;
//   color: #1d4ed8;
//   border: none;
//   padding: 12px 24px;
//   border-radius: 12px;
//   font-weight: 800;
//   font-size: 1rem;
//   cursor: pointer;
//   transition: all 0.2s ease;
//   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

//   &:hover {
//     background: #f8fafc;
//     transform: translateY(-2px);
//   }
// `;

// const ContentCard = styled.div`
//   background: rgba(255, 255, 255, 0.96);
//   border-radius: 22px;
//   padding: 24px;
//   box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);
//   border: 1px solid rgba(148, 163, 184, 0.16);

//   @media (max-width: 768px) {
//     padding: 18px;
//     border-radius: 18px;
//   }
// `;

// const HeaderRow = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   gap: 14px;
//   margin-bottom: 20px;
//   flex-wrap: wrap;
// `;

// const TitleContainer = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 14px;
// `;

// const Title = styled.h2`
//   color: #0f172a;
//   font-size: clamp(1.15rem, 1rem + 0.6vw, 1.6rem);
//   font-weight: 800;
//   margin: 0;
// `;

// const CountBadge = styled.div`
//   padding: 8px 14px;
//   border-radius: 999px;
//   background: #e0ecff;
//   color: #1d4ed8;
//   font-weight: 700;
//   font-size: 0.92rem;
// `;

// const AppraisalGrid = styled.div`
//   display: grid;
//   grid-template-columns: repeat(2, minmax(0, 1fr));
//   gap: 16px;

//   @media (max-width: 900px) {
//     grid-template-columns: 1fr;
//   }
// `;

// // 🔥 DYNAMIC APPRAISAL CARD: Changes color if ready to be scored
// const AppraisalCard = styled.button`
//   width: 100%;
//   padding: 18px;
//   border-radius: 18px;
//   cursor: pointer;
//   transition: all 0.25s ease;
//   text-align: left;
//   display: flex;
//   flex-direction: column;
//   gap: 16px;
  
//   background: ${({ isReady }) => isReady ? '#f0fdf4' : '#fff'};
//   border: 1px solid ${({ isReady }) => isReady ? '#86efac' : '#e2e8f0'};

//   &:hover {
//     transform: translateY(-2px);
//     box-shadow: 0 12px 24px rgba(15, 23, 42, 0.08);
//     border-color: ${({ isReady }) => isReady ? '#22c55e' : '#bfdbfe'};
//   }
// `;

// const TopRow = styled.div`
//   display: flex;
//   justify-content: space-between;
//   gap: 14px;
//   align-items: flex-start;
//   flex-wrap: wrap;
//   width: 100%;
// `;

// const UserInfo = styled.div`
//   min-width: 0;
// `;

// const UserName = styled.h3`
//   margin: 0 0 8px;
//   color: #0f172a;
//   font-size: 1.05rem;
//   font-weight: 800;
//   line-height: 1.4;
// `;

// const DetailText = styled.p`
//   margin: 4px 0;
//   color: #64748b;
//   font-size: 0.95rem;
//   line-height: 1.5;

//   span {
//     color: #334155;
//     font-weight: 700;
//   }
// `;

// const TagsContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   align-items: flex-end;
//   gap: 8px;
// `;

// const PeriodTag = styled.div`
//   padding: 6px 12px;
//   border-radius: 999px;
//   background: #eff6ff;
//   color: #1d4ed8;
//   font-weight: 700;
//   font-size: 0.85rem;
//   white-space: nowrap;
// `;

// const StatusBadge = styled.div`
//   padding: 6px 12px;
//   border-radius: 999px;
//   background: ${({ isReady }) => isReady ? '#dcfce7' : '#f1f5f9'};
//   color: ${({ isReady }) => isReady ? '#16a34a' : '#64748b'};
//   font-weight: 800;
//   font-size: 0.8rem;
//   display: flex;
//   align-items: center;
//   gap: 6px;
// `;

// const BottomRow = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   gap: 12px;
//   flex-wrap: wrap;
//   width: 100%;
// `;

// const SubmittedText = styled.p`
//   margin: 0;
//   color: #64748b;
//   font-size: 0.9rem;
// `;

// const ViewAction = styled.span`
//   color: ${({ isReady }) => isReady ? '#16a34a' : '#2563eb'};
//   font-weight: 800;
//   font-size: 0.92rem;
// `;

// const StateBox = styled.div`
//   text-align: center;
//   padding: 50px 20px;
//   border-radius: 18px;
//   background: ${({ type }) =>
//     type === 'error' ? '#fef2f2' : type === 'empty' ? '#f8fafc' : '#ffffff'};
//   color: ${({ type }) =>
//     type === 'error' ? '#dc2626' : '#64748b'};
//   border: 1px solid
//     ${({ type }) =>
//       type === 'error' ? '#fecaca' : '#e2e8f0'};
//   font-size: 1rem;
// `;

// /* ================= MAIN COMPONENT ================= */
// const SupervisorDashboard = ({ user }) => {
//   const [appraisals, setAppraisals] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchAppraisals = async () => {
//       try {
//         // 🔥 Replaced with the correct Backend Route using your configured api instance
//         const response = await api.get('/appraisal/supervisor-queue');
        
//         // The backend returns { success: true, data: appraisals }
//         setAppraisals(response.data.data || []);
//       } catch (err) {
//         setError(
//           err.response?.data?.message || err.message || 'Failed to fetch appraisals'
//         );
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchAppraisals();
//   }, []);

//   const handleAppraisalClick = (appraisalId) => {
//     navigate(`/supervisor/appraisal/${appraisalId}`);
//   };

//   return (
//     <AppContainer>
//       <NavBarSuper user={user} />

//       <PageWrapper>
//         <HeroCard>
//           <div>
//             <HeroTitle>Supervisor's Dashboard</HeroTitle>
//             <HeroText>
//               Review staff submissions, track appraisal periods, and open each record for full assessment.
//             </HeroText>
//           </div>
//           {/* 🔥 Manage Team Button smoothly integrated into the Hero Card */}
//           <ManageTeamButton onClick={() => navigate('/supervisor/team')}>
//             Manage My Team
//           </ManageTeamButton>
//         </HeroCard>

//         <ContentCard>
//           <HeaderRow>
//             <TitleContainer>
//               <Title>Staff Appraisal Submissions</Title>
//               <CountBadge>{appraisals.length} Submission{appraisals.length !== 1 ? 's' : ''}</CountBadge>
//             </TitleContainer>
//           </HeaderRow>

//           {loading ? (
//             <StateBox>Loading appraisals...</StateBox>
//           ) : error ? (
//             <StateBox type="error">Error: {error}</StateBox>
//           ) : appraisals.length > 0 ? (
//             <AppraisalGrid>
//               {appraisals.map((appraisal) => {
//                 // Determine user info robustly based on the populated backend data
//                 const staffInfo = appraisal.userId || appraisal.userDetails || {};
//                 const staffName = staffInfo.firstName 
//                   ? `${staffInfo.firstName} ${staffInfo.surname}` 
//                   : staffInfo.username || 'Unknown User';
                
//                 const isReady = appraisal.readyToBeScored;

//                 return (
//                   <AppraisalCard
//                     key={appraisal._id}
//                     isReady={isReady}
//                     onClick={() => handleAppraisalClick(appraisal._id)}
//                     type="button"
//                   >
//                     <TopRow>
//                       <UserInfo>
//                         <UserName>{staffName}</UserName>
//                         <DetailText>
//                           <span>Unit:</span> {staffInfo.unit || 'N/A'}
//                         </DetailText>
//                       </UserInfo>

//                       <TagsContainer>
//                         <PeriodTag>{appraisal.appraisalPeriod || 'No Period'}</PeriodTag>
//                         <StatusBadge isReady={isReady}>
//                           {isReady ? '🟢 Ready to Score' : '🟡 Draft'}
//                         </StatusBadge>
//                       </TagsContainer>
//                     </TopRow>

//                     <BottomRow>
//                       <SubmittedText>
//                         Last Updated: {appraisal.updatedAt
//                           ? new Date(appraisal.updatedAt).toLocaleDateString()
//                           : 'N/A'}
//                       </SubmittedText>
//                       <ViewAction isReady={isReady}>
//                         {isReady ? 'Score Appraisal →' : 'View Draft →'}
//                       </ViewAction>
//                     </BottomRow>
//                   </AppraisalCard>
//                 );
//               })}
//             </AppraisalGrid>
//           ) : (
//             <StateBox type="empty">No appraisals found for your team.</StateBox>
//           )}
//         </ContentCard>
//       </PageWrapper>

//       <Footer />
//     </AppContainer>
//   );
// };

// export default SupervisorDashboard;
//Logout



// import React, { useState, useEffect } from 'react';
// import styled from 'styled-components';
// import { useNavigate } from 'react-router-dom';
// import NavBarSuper from './NavBarSuper';
// import Footer from './Footer';
// import api from '../api';

// const AppContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   min-height: 100vh;
//   background: linear-gradient(180deg, #f8fafc 0%, #eef4ff 100%);
// `;

// const PageWrapper = styled.div`
//   flex: 1 0 auto;
//   width: min(1200px, calc(100% - 32px));
//   margin: 90px auto 30px;

//   @media (max-width: 768px) {
//     width: min(100%, calc(100% - 20px));
//     margin-top: 80px;
//   }
// `;

// const HeroCard = styled.div`
//   background: linear-gradient(135deg, #0f172a 0%, #1d4ed8 100%);
//   color: #fff;
//   border-radius: 24px;
//   padding: 28px;
//   margin-bottom: 22px;
//   box-shadow: 0 20px 40px rgba(15, 23, 42, 0.12);
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   flex-wrap: wrap;
//   gap: 20px;
// `;

// const HeroTitle = styled.h1`
//   margin: 0 0 8px;
//   font-size: clamp(1.4rem, 1.1rem + 1.2vw, 2.2rem);
//   font-weight: 800;
//   line-height: 1.2;
// `;

// const HeroText = styled.p`
//   margin: 0;
//   color: rgba(255, 255, 255, 0.86);
//   line-height: 1.6;
//   font-size: 0.98rem;
// `;

// const ManageTeamButton = styled.button`
//   background: #fff;
//   color: #1d4ed8;
//   border: none;
//   padding: 12px 24px;
//   border-radius: 12px;
//   font-weight: 800;
//   font-size: 1rem;
//   cursor: pointer;
//   transition: all 0.2s ease;
//   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

//   &:hover {
//     background: #f8fafc;
//     transform: translateY(-2px);
//   }
// `;

// const ContentCard = styled.div`
//   background: rgba(255, 255, 255, 0.96);
//   border-radius: 22px;
//   padding: 24px;
//   box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);
//   border: 1px solid rgba(148, 163, 184, 0.16);
// `;

// const HeaderRow = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   gap: 14px;
//   margin-bottom: 20px;
//   flex-wrap: wrap;
// `;

// const TitleContainer = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 14px;
// `;

// const Title = styled.h2`
//   color: #0f172a;
//   font-size: clamp(1.15rem, 1rem + 0.6vw, 1.6rem);
//   font-weight: 800;
//   margin: 0;
// `;

// const CountBadge = styled.div`
//   padding: 8px 14px;
//   border-radius: 999px;
//   background: #e0ecff;
//   color: #1d4ed8;
//   font-weight: 700;
//   font-size: 0.92rem;
// `;

// const AppraisalGrid = styled.div`
//   display: grid;
//   grid-template-columns: repeat(2, minmax(0, 1fr));
//   gap: 16px;

//   @media (max-width: 900px) {
//     grid-template-columns: 1fr;
//   }
// `;

// const AppraisalCard = styled.button`
//   width: 100%;
//   padding: 18px;
//   border-radius: 18px;
//   cursor: pointer;
//   transition: all 0.25s ease;
//   text-align: left;
//   display: flex;
//   flex-direction: column;
//   gap: 16px;
  
//   background: ${({ isReady }) => isReady ? '#f0fdf4' : '#fff'};
//   border: 1px solid ${({ isReady }) => isReady ? '#86efac' : '#e2e8f0'};

//   &:hover {
//     transform: translateY(-2px);
//     box-shadow: 0 12px 24px rgba(15, 23, 42, 0.08);
//     border-color: ${({ isReady }) => isReady ? '#22c55e' : '#bfdbfe'};
//   }
// `;

// const TopRow = styled.div`
//   display: flex;
//   justify-content: space-between;
//   gap: 14px;
//   align-items: flex-start;
//   flex-wrap: wrap;
//   width: 100%;
// `;

// const UserInfo = styled.div`
//   min-width: 0;
// `;

// const UserName = styled.h3`
//   margin: 0 0 8px;
//   color: #0f172a;
//   font-size: 1.05rem;
//   font-weight: 800;
//   line-height: 1.4;
// `;

// const DetailText = styled.p`
//   margin: 4px 0;
//   color: #64748b;
//   font-size: 0.95rem;
//   line-height: 1.5;

//   span {
//     color: #334155;
//     font-weight: 700;
//   }
// `;

// const TagsContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   align-items: flex-end;
//   gap: 8px;
// `;

// const PeriodTag = styled.div`
//   padding: 6px 12px;
//   border-radius: 999px;
//   background: #eff6ff;
//   color: #1d4ed8;
//   font-weight: 700;
//   font-size: 0.85rem;
//   white-space: nowrap;
// `;

// const StatusBadge = styled.div`
//   padding: 6px 12px;
//   border-radius: 999px;
//   background: ${({ isReady }) => isReady ? '#dcfce7' : '#f1f5f9'};
//   color: ${({ isReady }) => isReady ? '#16a34a' : '#64748b'};
//   font-weight: 800;
//   font-size: 0.8rem;
//   display: flex;
//   align-items: center;
//   gap: 6px;
// `;

// const BottomRow = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   gap: 12px;
//   flex-wrap: wrap;
//   width: 100%;
// `;

// const SubmittedText = styled.p`
//   margin: 0;
//   color: #64748b;
//   font-size: 0.9rem;
// `;

// const ViewAction = styled.span`
//   color: ${({ isReady }) => isReady ? '#16a34a' : '#2563eb'};
//   font-weight: 800;
//   font-size: 0.92rem;
// `;

// const StateBox = styled.div`
//   text-align: center;
//   padding: 50px 20px;
//   border-radius: 18px;
//   background: ${({ type }) =>
//     type === 'error' ? '#fef2f2' : type === 'empty' ? '#f8fafc' : '#ffffff'};
//   color: ${({ type }) =>
//     type === 'error' ? '#dc2626' : '#64748b'};
//   border: 1px solid
//     ${({ type }) =>
//       type === 'error' ? '#fecaca' : '#e2e8f0'};
//   font-size: 1rem;
// `;

// /* ================= MAIN COMPONENT ================= */
// const SupervisorDashboard = ({ user }) => {
//   const [appraisals, setAppraisals] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchAppraisals = async () => {
//       try {
//         const response = await api.get('/appraisal/supervisor-queue');
//         setAppraisals(response.data.data || []);
//       } catch (err) {
//         setError(
//           err.response?.data?.message || err.message || 'Failed to fetch appraisals'
//         );
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchAppraisals();
//   }, []);

//   const handleAppraisalClick = (appraisal) => {
//     const appraisalId = appraisal._id;

//     // Safely extract staff userId from the appraisal object
//     const staffUserId = appraisal.userId || 
//                        appraisal.user?._id || 
//                        appraisal.userDetails?._id || 
//                        appraisal.staffId;

//     if (!staffUserId) {
//       console.error("Could not find staff userId for appraisal:", appraisal);
//       alert("Could not determine staff user ID. Please contact admin.");
//       return;
//     }
//   console.log("staffUserId",staffUserId )
//     // Navigate to SupervisorAppraisalForm with appraisalId
//     // The form will use the staffUserId internally from the appraisal data
//     navigate(`/supervisor/appraisal/${appraisalId}`);
//   };

//   return (
//     <AppContainer>
//       <NavBarSuper user={user} />

//       <PageWrapper>
//         <HeroCard>
//           <div>
//             <HeroTitle>Supervisor's Dashboard</HeroTitle>
//             <HeroText>
//               Review staff submissions, track appraisal periods, and open each record for full assessment.
//             </HeroText>
//           </div>
//           <ManageTeamButton onClick={() => navigate('/supervisor/team')}>
//             Manage My Team
//           </ManageTeamButton>
//         </HeroCard>

//         <ContentCard>
//           <HeaderRow>
//             <TitleContainer>
//               <Title>Staff Appraisal Submissions</Title>
//               <CountBadge>{appraisals.length} Submission{appraisals.length !== 1 ? 's' : ''}</CountBadge>
//             </TitleContainer>
//           </HeaderRow>

//           {loading ? (
//             <StateBox>Loading appraisals...</StateBox>
//           ) : error ? (
//             <StateBox type="error">Error: {error}</StateBox>
//           ) : appraisals.length > 0 ? (
//             <AppraisalGrid>
//               {appraisals.map((appraisal) => {
//                 const staffInfo = appraisal.userId || appraisal.userDetails || appraisal.user || {};
//                 const staffName = staffInfo.firstName 
//                   ? `${staffInfo.firstName} ${staffInfo.surname || ''}`.trim()
//                   : staffInfo.username || 'Unknown Staff';

//                 const isReady = appraisal.readyToBeScored || false;

//                 return (
//                   <AppraisalCard
//                     key={appraisal._id}
//                     isReady={isReady}
//                     onClick={() => handleAppraisalClick(appraisal)}
//                     type="button"
//                   >
//                     <TopRow>
//                       <UserInfo>
//                         <UserName>{staffName}</UserName>
//                         <DetailText>
//                           <span>Unit:</span> {staffInfo.unit || 'N/A'}
//                         </DetailText>
//                       </UserInfo>

//                       <TagsContainer>
//                         <PeriodTag>{appraisal.appraisalPeriod || 'No Period'}</PeriodTag>
//                         <StatusBadge isReady={isReady}>
//                           {isReady ? '🟢 Ready to Score' : '🟡 Draft'}
//                         </StatusBadge>
//                       </TagsContainer>
//                     </TopRow>

//                     <BottomRow>
//                       <SubmittedText>
//                         Last Updated: {appraisal.updatedAt
//                           ? new Date(appraisal.updatedAt).toLocaleDateString()
//                           : 'N/A'}
//                       </SubmittedText>
//                       <ViewAction isReady={isReady}>
//                         {isReady ? 'Score Appraisal →' : 'View Draft →'}
//                       </ViewAction>
//                     </BottomRow>
//                   </AppraisalCard>
//                 );
//               })}
//             </AppraisalGrid>
//           ) : (
//             <StateBox type="empty">No appraisals found for your team.</StateBox>
//           )}
//         </ContentCard>
//       </PageWrapper>

//       <Footer />
//     </AppContainer>
//   );
// };

// export default SupervisorDashboard;



import React, { useState, useEffect } from 'react';
import styled, { keyframes, css } from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { 
  FaUsers, FaFileAlt, FaChevronRight, FaUserTie, FaCheckCircle, 
  FaClock, FaUserCog, FaLock, FaArrowLeft, FaUserEdit, FaEye, 
  FaEyeSlash, FaClipboardCheck, FaExchangeAlt, FaShieldAlt, FaSignOutAlt
} from 'react-icons/fa';
import NavBarSuper from './NavBarSuper';
import Footer from './Footer';
import api from '../api';
import { useTheme } from '../App'; 

const backendUrl = "https://api.stdl.site"; 

/* ================= ANIMATIONS ================= */
const float = keyframes`
  0% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-10px) rotate(1deg); }
  100% { transform: translateY(0px) rotate(0deg); }
`;

const slideUp = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const pulseGlow = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.4); }
  70% { box-shadow: 0 0 0 12px rgba(34, 197, 94, 0); }
  100% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0); }
`;

/* ================= ROOT THEME WRAPPER ================= */
const ThemeWrapper = styled.div`
  --bg-main: ${({ $isDarkMode }) => $isDarkMode ? '#0f172a' : '#f8fafc'};
  --bg-card: ${({ $isDarkMode }) => $isDarkMode ? '#1e293b' : '#ffffff'};
  --bg-card-hover: ${({ $isDarkMode }) => $isDarkMode ? '#27354f' : '#f1f5f9'};
  --text-primary: ${({ $isDarkMode }) => $isDarkMode ? '#f8fafc' : '#0f172a'};
  --text-secondary: ${({ $isDarkMode }) => $isDarkMode ? '#94a3b8' : '#64748b'};
  --border-color: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.06)'};
  
  --brand-primary: #2563eb;
  --accent-green: #22c55e;
  --accent-orange: #f59e0b;
  --accent-purple: #8b5cf6;

  background-color: var(--bg-main);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-x: hidden;
`;

/* 🔥 THE STRETCH FIX: Calculates exactly the remaining screen width */
const PageContainer = styled.main`
  flex: 1;
 
  box-sizing: border-box;
  padding: 120px 40px 80px; 
  transition: margin-left 0.35s ease, width 0.35s ease;

  @media (max-width: 1024px) {
    margin-left: 0;
    width: 100%;
    padding: 110px 20px 80px; 
  }
`;

const InnerWrap = styled.div`
  width: 100%;
  max-width: 1600px; /* Allows stretching while keeping ultra-wides clean */
  margin: 0 auto;
`;

/* ================= CREATIVE HERO BANNER ================= */
const HeroBanner = styled.div`
  background: ${({ $isDarkMode }) => $isDarkMode ? 
    'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)' : 
    'linear-gradient(135deg, #2563eb 0%, #1e3a8a 100%)'};
  border-radius: 28px;
  padding: 40px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0,0,0,0.1);
  margin-bottom: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 30px;
  width: 100%;
  box-sizing: border-box;
  animation: ${slideUp} 0.5s ease-out forwards;

  &::before {
    content: ""; position: absolute; top: -50px; right: -50px; width: 300px; height: 300px;
    background: radial-gradient(circle, rgba(255,255,255,0.15) 0%, rgba(255,255,255,0) 70%);
    border-radius: 50%; animation: ${float} 8s ease-in-out infinite;
  }
  @media (max-width: 768px) { padding: 30px 20px; border-radius: 20px; flex-direction: column; align-items: stretch; }
`;

const HeroProfile = styled.div`
  display: flex; align-items: center; gap: 24px; position: relative; z-index: 2;
  @media (max-width: 576px) { flex-direction: column; align-items: flex-start; gap: 16px; }
`;

const AvatarRing = styled.div`
  width: 86px; height: 86px; border-radius: 24px; padding: 3px;
  background: linear-gradient(135deg, #60a5fa, #a78bfa); flex-shrink: 0;
  img, div {
    width: 100%; height: 100%; border-radius: 20px; object-fit: cover;
    background: var(--bg-card); display: grid; place-items: center;
    color: var(--brand-primary); font-size: 2rem; font-weight: 800;
  }
`;

const HeroTextInfo = styled.div` color: white; `;
const SuperBadge = styled.span`
  display: inline-block; background: rgba(255,255,255,0.2); backdrop-filter: blur(8px);
  padding: 6px 14px; border-radius: 999px; font-size: 0.75rem; font-weight: 800;
  text-transform: uppercase; margin-bottom: 12px; border: 1px solid rgba(255,255,255,0.3);
`;
const WelcomeTitle = styled.h1` margin: 0 0 8px; font-size: clamp(1.6rem, 2vw, 2.2rem); font-weight: 900; line-height: 1.2; `;
const WelcomeSub = styled.p` margin: 0; color: rgba(255,255,255,0.85); font-size: 0.95rem; max-width: 500px; line-height: 1.5; `;

const SwitchRoleBtn = styled.button`
  position: relative; z-index: 2; background: white; color: #0f172a; border: none; padding: 16px 28px; border-radius: 16px; font-weight: 800; font-size: 0.95rem; cursor: pointer; display: flex; align-items: center; gap: 12px; justify-content: center; box-shadow: 0 10px 25px rgba(0,0,0,0.15); transition: all 0.2s;
  &:hover { transform: translateY(-4px); background: #f8fafc; }
`;

/* ================= MODERN SCORECARDS ================= */
const ScorecardGrid = styled.div` display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 24px; margin-bottom: 40px; `;

const ScoreCard = styled.div`
  background: var(--bg-card); border: 1px solid var(--border-color); border-radius: 24px;
  padding: 28px; box-shadow: 0 4px 15px rgba(0,0,0,0.03); display: flex; align-items: center; gap: 20px; transition: transform 0.2s ease;
  
  ${({ $isPulsing }) => $isPulsing && css` animation: ${pulseGlow} 2s infinite; `}

  &:hover { transform: translateY(-6px); box-shadow: 0 15px 30px rgba(0,0,0,0.08); }
`;

const IconWrapper = styled.div`
  width: 60px; height: 60px; border-radius: 18px; background: ${({ bg }) => bg || 'var(--brand-light)'};
  color: ${({ color }) => color || 'var(--brand-primary)'}; display: flex; align-items: center; justify-content: center; font-size: 1.6rem; flex-shrink: 0;
`;

const ScoreData = styled.div` display: flex; flex-direction: column; `;
const ScoreNumber = styled.div` font-size: 2.2rem; font-weight: 900; color: var(--text-primary); line-height: 1; margin-bottom: 8px; `;
const ScoreText = styled.div` font-size: 0.8rem; font-weight: 700; color: var(--text-secondary); text-transform: uppercase; `;

const ProgressCircle = styled.div`
  width: 60px; height: 60px; border-radius: 50%; display: flex; align-items: center; justify-content: center; flex-shrink: 0;
  background: conic-gradient( var(--accent-purple) ${({ percentage }) => percentage}%, var(--border-color) 0 );
  &::after { content: ""; width: 46px; height: 46px; background: var(--bg-card); border-radius: 50%; position: absolute; }
  span { position: relative; z-index: 1; font-size: 0.95rem; font-weight: 800; color: var(--text-primary); }
`;

/* ================= QUICK ACTIONS ================= */
const QuickActionsGrid = styled.div` display: grid; grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); gap: 24px; margin-bottom: 40px; `;



/* ================= CONTENT SECTIONS ================= */
const SectionCard = styled.div` background: var(--bg-card); border: 1px solid var(--border-color); border-radius: 28px; padding: 32px; margin-bottom: 40px; @media (max-width: 768px) { padding: 24px; } `;
const SectionHeader = styled.div` display: flex; justify-content: space-between; align-items: center; margin-bottom: 32px; flex-wrap: wrap; gap: 16px; `;
const SectionTitle = styled.h2` margin: 0; font-size: 1.35rem; font-weight: 900; color: var(--text-primary); display: flex; align-items: center; gap: 12px; `;
const Badge = styled.div` background: rgba(59,130,246,0.1); color: var(--brand-primary); padding: 6px 14px; border-radius: 999px; font-weight: 800; font-size: 0.85rem; `;
const CardGrid = styled.div` display: grid; grid-template-columns: repeat(auto-fill, minmax(320px, 1fr)); gap: 24px; `;

const ItemCard = styled.div`
  background: var(--bg-main); border: 1px solid var(--border-color); border-radius: 20px; padding: 24px;
  display: flex; flex-direction: column; gap: 16px; cursor: pointer; transition: transform 0.2s;
  &:hover { border-color: var(--brand-primary); transform: translateY(-4px); }
`;

const CardTop = styled.div` display: flex; justify-content: space-between; align-items: flex-start; gap: 16px; `;
const NameText = styled.h3` margin: 0 0 6px; font-size: 1.1rem; font-weight: 800; color: var(--text-primary); `;
const SubText = styled.p` margin: 2px 0; font-size: 0.9rem; color: var(--text-secondary); span { font-weight: 700; color: var(--text-primary); } `;

const StatusPill = styled.div`
  padding: 6px 12px; border-radius: 999px; font-size: 0.75rem; font-weight: 800; display: flex; align-items: center; gap: 6px; white-space: nowrap;
  background: ${({ ready, $isDarkMode }) => ready ? ($isDarkMode ? 'rgba(34,197,94,0.15)' : '#dcfce7') : ($isDarkMode ? 'rgba(245,158,11,0.15)' : '#fef3c7')};
  color: ${({ ready, $isDarkMode }) => ready ? ($isDarkMode ? '#4ade80' : '#16a34a') : ($isDarkMode ? '#fbbf24' : '#d97706')};
`;

const CardBottom = styled.div` display: flex; justify-content: space-between; align-items: center; padding-top: 16px; border-top: 1px solid var(--border-color); margin-top: auto; `;
const OutlineBtn = styled.button` background: transparent; color: var(--brand-primary); border: 2px solid var(--border-color); border-radius: 12px; padding: 10px 16px; font-weight: 800; font-size: 0.9rem; cursor: pointer; width: 100%; display: flex; justify-content: center; align-items: center; gap: 8px; transition: all 0.2s; &:hover { border-color: var(--brand-primary); background: rgba(59,130,246,0.1); } `;

/* ================= INLINE SETTINGS STYLES ================= */
const BackButton = styled.button` display: flex; align-items: center; gap: 8px; background: transparent; color: var(--text-secondary); border: none; font-size: 1rem; font-weight: 800; cursor: pointer; margin-bottom: 24px; transition: color 0.2s; &:hover { color: var(--brand-primary); } `;
const Form = styled.form` display: flex; flex-direction: column; gap: 24px; max-width: 700px; `;
const FormGroup = styled.div` display: flex; flex-direction: column; gap: 8px; `;
const Label = styled.label` font-size: 0.95rem; font-weight: 800; color: var(--text-primary); `;
const Input = styled.input` width: 100%; padding: 16px; border-radius: 14px; border: 2px solid var(--border-color); font-size: 1rem; background: var(--bg-main); color: var(--text-primary); transition: all 0.2s; box-sizing: border-box; &:focus { border-color: var(--brand-primary); outline: none; } &:disabled { opacity: 0.6; cursor: not-allowed; } `;
const SubmitBtn = styled.button` background: var(--brand-primary); color: white; border: none; padding: 16px 32px; border-radius: 14px; font-size: 1rem; font-weight: 800; cursor: pointer; align-self: flex-start; transition: all 0.2s; &:hover:not(:disabled) { background: #1d4ed8; transform: translateY(-2px); box-shadow: 0 4px 10px rgba(0,0,0,0.1); } &:disabled { opacity: 0.6; cursor: not-allowed; } `;
const Message = styled.div` padding: 16px; border-radius: 14px; font-weight: 700; background: ${({ type }) => type === 'success' ? 'rgba(34,197,94,0.1)' : 'rgba(239,68,68,0.1)'}; color: ${({ type }) => type === 'success' ? 'var(--accent-green)' : '#ef4444'}; border: 1px solid currentColor; margin-bottom: 24px; `;

/* ================= MAIN COMPONENT ================= */
const SupervisorDashboard = ({ user, setUser }) => {
  const { isDarkMode } = useTheme();
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();

  const [activeView, setActiveView] = useState('dashboard'); 
  const [appraisals, setAppraisals] = useState([]);
  const [myTeam, setMyTeam] = useState([]);
  const [loading, setLoading] = useState(true);

  // Forms
  const [profileData, setProfileData] = useState({ username: user?.username || user?.name || "", email: user?.email || "" });
  const [profileMsg, setProfileMsg] = useState({ type: "", text: "" });
  const [passwordData, setPasswordData] = useState({ currentPassword: "", newPassword: "", confirmPassword: "" });
  const [passwordMsg, setPasswordMsg] = useState({ type: "", text: "" });
  const [showPwd, setShowPwd] = useState(false);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        setLoading(true);
        const [appRes, teamRes] = await Promise.all([
          api.get('/appraisal/supervisor-queue'), 
          api.get('/auth/my-team')
        ]);
        setAppraisals(appRes.data.data || []);
        setMyTeam(teamRes.data.data || []);
      } catch (err) { 
        console.error(err); 
      } finally { 
        setLoading(false); 
      }
    };
    fetchDashboardData();
  }, []);

  

  const displayName = `${user?.title?.trim() || ""} ${user?.firstName?.trim() || user?.name || "User"}`.trim();
  const initials = (user?.firstName || user?.name || "U").substring(0, 2).toUpperCase();

  // 🔥 DYNAMIC METRICS CALCULATIONS 🔥
  const teamSize = myTeam.length;
  const readyCount = appraisals.filter(a => a.readyToBeScored).length;
  const draftCount = appraisals.filter(a => !a.readyToBeScored).length;
  const actionRate = appraisals.length > 0 ? Math.round((readyCount / appraisals.length) * 100) : 0;

  const handleProfileSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await api.put('/auth/profile', { email: profileData.email });
      if (res.data.success) {
        const fetchRes = await api.get("/auth/profile");
        if (fetchRes.data.success) {
          localStorage.setItem("user", JSON.stringify(fetchRes.data.user));
          if (setUser) setUser(fetchRes.data.user);
        }
        setProfileMsg({ type: "success", text: "Profile updated successfully!" });
      }
    } catch (err) { setProfileMsg({ type: "error", text: "Failed to update profile." }); }
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    if (passwordData.newPassword !== passwordData.confirmPassword) return setPasswordMsg({ type: "error", text: "Passwords don't match." });
    try {
      await api.put('/auth/change-password', { currentPassword: passwordData.currentPassword, newPassword: passwordData.newPassword });
      setPasswordMsg({ type: "success", text: "Password changed securely." });
      setPasswordData({ currentPassword: "", newPassword: "", confirmPassword: "" });
    } catch (err) { setPasswordMsg({ type: "error", text: "Failed to change password." }); }
  };

  return (
    <ThemeWrapper collapsed={collapsed} $isDarkMode={isDarkMode}>
      <NavBarSuper user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
    

      <PageContainer collapsed={collapsed}>
        <InnerWrap>
          {/* ================= HERO BANNER ================= */}
          <HeroBanner $isDarkMode={isDarkMode}>
            <HeroProfile>
              <AvatarRing>
                {user?.profilePicture ? (
                  <img src={user.profilePicture.startsWith("http") ? user.profilePicture : `${backendUrl}${user.profilePicture}`} alt="Avatar" onError={(e) => e.target.style.display="none"} />
                ) : ( <div>{initials}</div> )}
              </AvatarRing>
              <HeroTextInfo>
                <SuperBadge>Supervisor Mode</SuperBadge>
                <WelcomeTitle>
                  {activeView === 'dashboard' ? `Welcome back, ${displayName}` : 
                  activeView === 'profile' ? 'Profile Settings' : 'Security Center'}
                </WelcomeTitle>
                <WelcomeSub>
                  {activeView === 'dashboard' ? 'Your team’s performance metrics and pending appraisals are ready for review.' :
                  'Manage your account configurations securely.'}
                </WelcomeSub>
              </HeroTextInfo>
            </HeroProfile>

            {/* Replace your existing SwitchRoleBtn with this: */}
{activeView === 'dashboard' && (
  <SwitchRoleBtn onClick={() => {
    sessionStorage.setItem('fromCommandCenter', 'true'); // 🔥 Leaves the breadcrumb!
    navigate('/dashboard');
  }}>
    <FaExchangeAlt /> Switch to Staff Dashboard
  </SwitchRoleBtn>
)}
          </HeroBanner>

          {/* ================= PROFILE SETTINGS VIEW ================= */}
          {activeView === 'profile' && (
            <div>
              <BackButton onClick={() => setActiveView('dashboard')}><FaArrowLeft /> Return to Command Center</BackButton>
              <SectionCard>
                <SectionHeader><SectionTitle><FaUserEdit style={{color: 'var(--brand-primary)'}} /> Edit Profile</SectionTitle></SectionHeader>
                {profileMsg.text && <Message type={profileMsg.type}>{profileMsg.text}</Message>}
                <Form onSubmit={handleProfileSubmit}>
                  <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap' }}>
                    <FormGroup style={{ flex: 1, minWidth: '250px' }}>
                      <Label>Username (Locked)</Label>
                      <Input type="text" value={profileData.username} disabled />
                    </FormGroup>
                    <FormGroup style={{ flex: 1, minWidth: '250px' }}>
                      <Label>Email Address</Label>
                      <Input type="email" value={profileData.email} onChange={(e) => setProfileData({...profileData, email: e.target.value})} required />
                    </FormGroup>
                  </div>
                  <SubmitBtn type="submit">Save Changes</SubmitBtn>
                </Form>
              </SectionCard>
            </div>
          )}

          {/* ================= SECURITY VIEW ================= */}
          {activeView === 'security' && (
            <div>
              <BackButton onClick={() => setActiveView('dashboard')}><FaArrowLeft /> Return to Command Center</BackButton>
              <SectionCard>
                <SectionHeader><SectionTitle><FaShieldAlt style={{color: 'var(--brand-primary)'}} /> Security Settings</SectionTitle></SectionHeader>
                {passwordMsg.text && <Message type={passwordMsg.type}>{passwordMsg.text}</Message>}
                <Form onSubmit={handlePasswordSubmit}>
                  <FormGroup>
                    <Label>Current Password</Label>
                    <div style={{position: 'relative'}}>
                      <Input type={showPwd ? "text" : "password"} value={passwordData.currentPassword} onChange={(e) => setPasswordData({...passwordData, currentPassword: e.target.value})} required />
                      <button type="button" onClick={() => setShowPwd(!showPwd)} style={{position: 'absolute', right: '16px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', color: 'var(--text-secondary)', cursor: 'pointer', fontSize: '1.2rem'}}>{showPwd ? <FaEyeSlash/> : <FaEye/>}</button>
                    </div>
                  </FormGroup>
                  <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap' }}>
                    <FormGroup style={{ flex: 1, minWidth: '250px' }}>
                      <Label>New Password</Label>
                      <Input type={showPwd ? "text" : "password"} value={passwordData.newPassword} onChange={(e) => setPasswordData({...passwordData, newPassword: e.target.value})} required />
                    </FormGroup>
                    <FormGroup style={{ flex: 1, minWidth: '250px' }}>
                      <Label>Confirm Password</Label>
                      <Input type={showPwd ? "text" : "password"} value={passwordData.confirmPassword} onChange={(e) => setPasswordData({...passwordData, confirmPassword: e.target.value})} required />
                    </FormGroup>
                  </div>
                  <SubmitBtn type="submit">Update Password</SubmitBtn>
                </Form>
              </SectionCard>
            </div>
          )}

          {/* ================= DASHBOARD VIEW ================= */}
          {activeView === 'dashboard' && (
            <>
              {/* 🔥 DYNAMIC SCORECARDS */}
              <ScorecardGrid>
                <ScoreCard>
                  <IconWrapper bg="rgba(59,130,246,0.1)" color="var(--brand-primary)"><FaUsers /></IconWrapper>
                  <ScoreData><ScoreNumber>{loading ? '-' : teamSize}</ScoreNumber><ScoreText>Total Staff</ScoreText></ScoreData>
                </ScoreCard>

                <ScoreCard $isPulsing={readyCount > 0}>
                  <IconWrapper bg="rgba(34,197,94,0.15)" color="var(--accent-green)"><FaClipboardCheck /></IconWrapper>
                  <ScoreData><ScoreNumber>{loading ? '-' : readyCount}</ScoreNumber><ScoreText>Ready to Score</ScoreText></ScoreData>
                </ScoreCard>

                <ScoreCard>
                  <IconWrapper bg="rgba(245,158,11,0.15)" color="var(--accent-orange)"><FaClock /></IconWrapper>
                  <ScoreData><ScoreNumber>{loading ? '-' : draftCount}</ScoreNumber><ScoreText>Drafts Pending</ScoreText></ScoreData>
                </ScoreCard>

                <ScoreCard>
                  <ProgressCircle percentage={actionRate || 0}><span>{loading ? '-' : `${actionRate}%`}</span></ProgressCircle>
                  <ScoreData><ScoreNumber style={{fontSize: '1.4rem'}}>Action Rate</ScoreNumber><ScoreText style={{textTransform: 'none'}}>Appraisals Ready</ScoreText></ScoreData>
                </ScoreCard>
              </ScorecardGrid>

              {/* TEAM DIRECTORY */}
              <SectionCard>
                <SectionHeader>
                  <SectionTitle><FaUserTie style={{color: 'var(--brand-primary)'}} /> My Team Directory</SectionTitle>
                  <Badge>{myTeam.length} Members</Badge>
                </SectionHeader>
                <CardGrid>
                  {myTeam.map((staff) => (
                    <ItemCard key={staff._id} onClick={() => navigate(`/supervisor/goals/${staff._id}`)} clickable>
                      <CardTop>
                        <div>
                          <NameText>{staff.firstName} {staff.surname}</NameText>
                          <SubText>Role: <span>{staff.roles || 'N/A'}</span></SubText>
                          <SubText>Unit: <span>{staff.unit || 'N/A'}</span></SubText>
                        </div>
                      </CardTop>
                      <CardBottom>
                        <OutlineBtn>View Goals & Perfomance <FaChevronRight size={10}/></OutlineBtn>
                      </CardBottom>
                    </ItemCard>
                  ))}
                </CardGrid>
              </SectionCard>

              {/* APPRAISALS */}
              <SectionCard>
                <SectionHeader>
                  <SectionTitle><FaFileAlt style={{color: 'var(--brand-primary)'}} /> Appraisal Submissions</SectionTitle>
                  <Badge>{appraisals.length} Submissions</Badge>
                </SectionHeader>
                <CardGrid>
                  {appraisals.map((appraisal) => {
                    const staffInfo = appraisal.userId || appraisal.user || appraisal.userDetails || {};
                    const isReady = appraisal.readyToBeScored || false;
                    return (
                      <ItemCard key={appraisal._id} highlight={isReady} clickable onClick={() => navigate(`/supervisor/appraisal/${appraisal._id}`)}>
                        <CardTop>
                          <div>
                            <NameText>{staffInfo.firstName ? `${staffInfo.firstName} ${staffInfo.surname}` : 'Unknown Staff'}</NameText>
                            <SubText>Period: <span>{appraisal.appraisalPeriod}</span></SubText>
                          </div>
                          <StatusPill ready={isReady} $isDarkMode={isDarkMode}>
                            {isReady ? <><FaCheckCircle/> Ready</> : <><FaClock/> Draft</>}
                          </StatusPill>
                        </CardTop>
                        <CardBottom>
                          <SubText style={{fontSize: '0.8rem'}}>Updated: {new Date(appraisal.updatedAt).toLocaleDateString()}</SubText>
                          <div style={{color: isReady ? 'var(--accent-green)' : 'var(--brand-primary)', fontWeight: 800, fontSize: '0.9rem', display: 'flex', alignItems: 'center', gap: '4px'}}>
                            {isReady ? 'Score Now' : 'View Draft'} <FaChevronRight size={10} />
                          </div>
                        </CardBottom>
                      </ItemCard>
                    );
                  })}
                </CardGrid>
              </SectionCard>

            </>
          )}
        </InnerWrap>
      </PageContainer>
      <Footer />
    </ThemeWrapper>
  );
};

export default SupervisorDashboard;